module.exports = __webpack_public_path__ + "static/img/m8.592dc66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m8.png
// module id = ObXv
// module chunks = 12